import { render, staticRenderFns } from "./livelihood.vue?vue&type=template&id=7b56012a"
import script from "./livelihood.vue?vue&type=script&lang=js"
export * from "./livelihood.vue?vue&type=script&lang=js"
import style0 from "./livelihood.vue?vue&type=style&index=0&id=7b56012a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports